import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import { ReactNode } from "react";
import Interval from "../../../models/communications/Interval";
import IntervalSet from "../../../models/communications/IntervalSet";
import Interaction from "../../../models/interactions/Interaction";
import InteractionNode from "../../../models/interactions/InteractionNode";
import InteractionNodeInterval from "../../../models/interactions/InteractionNodeInterval";
import MatrixCell from "./MatrixCell";
import MatrixControls from "./controls/MatrixControls";
import MatrixIntervalControls from "./controls/MatrixIntervalControls";
import InteractionParentInterval from "../../../models/interactions/InteractionParentInterval";
import Button from "@mui/material/Button";
import { useStoreDispatch } from "../../../store/Hooks";
import useHttp from "../../../hooks/useHttp";
import { interactionTreeSliceActions } from "../../../store/slices/InteractionTreeSlice";
import {
  compareIntervalsByDay,
  interactionsNodesHandleFetch,
  stateDeepCopy,
} from "../../../helpers/DataUpdateHelper";
import { navSliceActions } from "../../../store/slices/NavSlice";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import InteractionIntervalsButton from "../../interactions/ui/InteractionIntervalsButton";
import InteractionSettings from "../../../models/config/InteractionSettings";
import CommunicationSet from "../../../models/communications/CommunicationSet";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Tooltip from "@mui/material/Tooltip";
import { findCommSetEarliestStartDay } from "../../../helpers/IntervalSetHelper";
import { MatrixHeadingControlsRowProps } from "./MatrixCommSetsControlsRow";

export const MatrixHeadingControlsRowStyled = styled(TableRow)(({ theme }) => ({
  div: {
    backgroundColor: "white",
    padding: "0px",
  },
}));
// define schema for data returned from create interval column
export interface CreateNewInteractionMatrixColumnReturnProps {
  interval_id: number;
  interaction_node_interval_ids: number[];
}


const MatrixHeadingControlsRow = (props: MatrixHeadingControlsRowProps) => {
  const [controlsBorderStyle, setControlsBorderStyle] = useState<any>({
    textAlign: "center",
    paddingTop: "0px",
    paddingBottom: "0px",
    backgroundColor:"#f0faf0",
    borderRight:"2pt solid #C8C6C6"

  });

  const iconCellStyle = {
    paddingTop: "10px",
    paddingBottom: "0px",
    textAlign: "center",
    whiteSpace: "nowrap",
    backgroundColor:"#dfe8df",
    borderRight:"2pt solid #C8C6C6",
    position: "sticky",
    left: 0,
    zIndex: 2
  };

  /* start reordering logic */
  const intervalsToCommSetsMap = new Map<number | null, Array<Interval>>();

  // returns array of intervals for this commsetID ordered by start_day
  const getOrderedIntervalsForCommSet = (commSetID: number | null) => {
    const intervalsForThisCommSet = props.associatedIntervals.filter(
      (interval) => {
        return interval.communication_set_id === commSetID;
      },
    );
    return intervalsForThisCommSet.sort(compareIntervalsByDay);
  };

  // iterate through existing commsets, attach corresponding intervals
  for (let i = 0; i < props.associatedCommSets.length; i++) {
    const thisHereCommSet = props.associatedCommSets[i];
    const key = thisHereCommSet.id;

    const intervalsForThisCommSet = getOrderedIntervalsForCommSet(key);
    intervalsToCommSetsMap.set(key, intervalsForThisCommSet);
  }

  // now we need to add intervals that have null commset
  // use null as the key
  const intervalsForThisCommSetNull = getOrderedIntervalsForCommSet(null);
  // console.log("null intervals for intervalSet " + props.intervalSetID)
  // console.log(intervalsForThisCommSetNull)
  intervalsToCommSetsMap.set(null, intervalsForThisCommSetNull);

  const commSetsMapEntries = [...intervalsToCommSetsMap.entries()];
  commSetsMapEntries.sort((a, b) => {
    const startDayA = findCommSetEarliestStartDay(
      a[0],
      props.associatedIntervals || [],
    );
    const startDayB = findCommSetEarliestStartDay(
      b[0],
      props.associatedIntervals || [],
    );

    return startDayA - startDayB;
  });

  const sortedMap = new Map(commSetsMapEntries); // ***this successfully re-orders the commset top row
  const jsxArray = [];

  for (const objArray of sortedMap.values()) {
    // Iterate over the array of objects and create JSX elements
    const jsxElements = objArray.map((associatedInterval: Interval) => {
      return (
        <MatrixCell
          align="center"
          key={associatedInterval.id}
          style={controlsBorderStyle}
        >
          <MatrixIntervalControls
            setID={props.currentSet}
            parentID={props.currentParent}
            associatedInterval={associatedInterval}
            editMode={props.editMode}
            intervalSetName={props.intervalSetName}
            intervalSet={props.intervalSet}
            commSetsForIntervalSet={props.associatedCommSets}
          />
        </MatrixCell>
      );
    });

    // Concatenate the JSX elements to the new array
    jsxArray.push(...jsxElements);
  }

  return (
    <MatrixHeadingControlsRowStyled>
      <MatrixCell colSpan={1} style={iconCellStyle}>
        <Tooltip title="Intervals">
          <CalendarMonthIcon style={{ color: "lightgray", fontSize: "20pt" }} />
        </Tooltip>
      </MatrixCell>
      {jsxArray}
      {/* {matrixCellRendering} */}
    </MatrixHeadingControlsRowStyled>
  );
};

export default MatrixHeadingControlsRow;
